export enum Experiments {
  FAKE_EXPERIMENT_NAME = 'Fake Experiment',
  LIFE_SIMPLIFIED_ESTIMATES_EXPERIMENT_NAME = 'Life Simplified Estimates', // LIFE-3237 - Remove if Simplified Estimates loses
  HOUSEHOLD_COMMON_APP_V3_EXPERIMENT_NAME = 'Household Common App V3',
}

export enum Variations {
  FAKE_VARIANT_NAME = 'Fake Variant',
  LIFE_SIMPLIFIED_ESTIMATES_VARIANT_NAME = 'Life Simplified Estimates Variant', // LIFE-3237 - Remove if Simplified Estimates loses
  HOUSEHOLD_COMMON_APP_V3_VARIANT_NAME = 'Household Common App V3 Variant',
}

export interface VariationMap {
  [Experiments.FAKE_EXPERIMENT_NAME]: Variations.FAKE_VARIANT_NAME;
  [Experiments.LIFE_SIMPLIFIED_ESTIMATES_EXPERIMENT_NAME]: Variations.LIFE_SIMPLIFIED_ESTIMATES_VARIANT_NAME; // LIFE-3237 - Remove if Simplified Estimates loses
  [Experiments.HOUSEHOLD_COMMON_APP_V3_EXPERIMENT_NAME]: Variations.HOUSEHOLD_COMMON_APP_V3_VARIANT_NAME;
}
